import { createFileRoute, Outlet, useRouterState } from "@tanstack/react-router";
import { GameShell } from "@/components/game/GameShell";
import { PaymentTestModeBanner } from "@/components/PaymentTestModeBanner";
import { useWakeLock } from "@/hooks/use-wake-lock";

export const Route = createFileRoute("/_app/game")({
  head: () => ({
    meta: [{ name: "robots", content: "noindex, nofollow" }],
  }),
  component: GameLayout,
});

const NO_SHELL = new Set(["/game", "/game/", "/game/onboarding"]);

function GameLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  useWakeLock(true);
  if (NO_SHELL.has(pathname)) {
    return (
      <>
        <PaymentTestModeBanner />
        <Outlet />
      </>
    );
  }
  return (
    <GameShell>
      <PaymentTestModeBanner />
      <Outlet />
    </GameShell>
  );
}
